import $ from 'jquery';
import {endGallerySwipe} from "./phaseActions/end-swipe";
import {SWIPE_DIRECTION_LEFT, SWIPE_DIRECTION_RIGHT} from "./consts";

const handleGalleryBtn = function (event) {
    event.preventDefault();

    if ($(this).css('opacity') == '0')
        return false;

    const galleryBlock = $(this).parents('.material-content-gallery');

    if (galleryBlock.attr('animation'))
        return false;

    let direction = SWIPE_DIRECTION_LEFT;

    switch ($(this).data('type')) {
        case 'prev':
            direction = SWIPE_DIRECTION_RIGHT;
            break;

        case 'next':
            direction = SWIPE_DIRECTION_LEFT;
            break;
    }

    endGallerySwipe(galleryBlock, direction);

    return false;
};

export const bindHandlerToGalleryButtons = () => {
    $(document).off('click', '.gallery-btn');
    $(document).on('click', '.gallery-btn', handleGalleryBtn);
};
